module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzVDNkJDMCIgZD0iTTQwIDQwYy02LjkgMC0xNiA0LTE2IDRWMjJzOS00IDE4LTRsLTIgMjJ6Ii8+PHBhdGggZmlsbD0iIzc5ODZDQiIgZD0iTTggNDBjNi45IDAgMTYgNCAxNiA0VjIycy05LTQtMTgtNGwyIDIyeiIvPjxnIGZpbGw9IiNGRkI3NEQiPjxjaXJjbGUgY3g9IjI0IiBjeT0iMTIiIHI9IjgiLz48cGF0aCBkPSJNNDEgMzJoMWMuNiAwIDEtLjQgMS0xdi00YzAtLjYtLjQtMS0xLTFoLTFjLTEuNyAwLTMgMS4zLTMgM3MxLjMgMyAzIDN6TTcgMjZINmMtLjYgMC0xIC40LTEgMXY0YzAgLjYuNCAxIDEgMWgxYzEuNyAwIDMtMS4zIDMtM3MtMS4zLTMtMy0zeiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/reading.svg
// module id = 3910
// module chunks = 0